module.exports = __webpack_public_path__ + "2026310:ef9a7edf554eddff21f3/img/big_image@2x.a17ee50.jpg";